module.exports = __webpack_public_path__ + "media/images/cms/img_slide_13-75e41c110b6c27e744c19a19e4dfe88c.jpg";